import http from '@/utils/request';

// 应收单管理列表
export const getReceiveList = (data = {}) => {
  const url = '/receipt/receive/bopList';
  return http.post({
    url,
    data,
  });
};

// 应收单详情
export const getReceiveDetail = (data = {}) => {
  const url = '/receipt/receive/detail';
  return http.post({
    url,
    data,
  });
};

// 应收单添加收款
export const addReceipt = (data = {}) => {
  return http.post({
    url: '/order/inner/receipt/add',
    data,
  });
};

// 获取账户列表
export const getAakAcctList = (data = {}) => {
  return http.post({
    url: '/receipt/cashier/bakAcctList',
    data,
  });
};

// 详情-操作日志
export const getOperationLogList = (data = {}) => {
  return http.post({
    url: '/order/inner/order/operationLogList',
    data,
  });
};
